import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetExpansionFeatures from '@/pages/Tools/MyCharacters/CharacterSheet/CharacterSheetExpansionFeatures.vue';
import CharacterSheetSuperiorityAddManeuver from '@/pages/Tools/MyCharacters/CharacterSheet/CharacterSheetSuperiorityAddManeuver.vue';
import { namespace } from 'vuex-class';
const maneuversModule = namespace('maneuvers');
const maneuverRatios = {
    Fighter: {
        baseClass: 0.5,
        'Tactical Specialist': 1,
        'Fireteam Specialist': 1,
        'Fireteam Specialist (Companion)': 1
    },
    Scholar: {
        baseClass: 1
    },
    Scout: {
        baseClass: 0,
        'Deadeye Technique': 0.5
    }
};
let CharacterBuilderClassManeuvers = class CharacterBuilderClassManeuvers extends Vue {
    created() {
        this.fetchManeuvers();
    }
    get maneuversSelected() {
        const classManeuvers = (this.myClass).maneuvers || [];
        const archetypeManeuvers = (this.isArchetypeSuperiority && this.myClass.archetype && this.myClass.archetype.maneuvers) || [];
        return [...classManeuvers, ...archetypeManeuvers];
    }
    get maneuversSelectedData() {
        return this.maneuvers.filter(({ name }) => this.maneuversSelected.includes(name));
    }
    get classSuperiority() {
        return maneuverRatios[this.classData.name] || { baseClass: 0 };
    }
    get isArchetypeSuperiority() {
        if (!this.classSuperiority || !this.archetypeData)
            return false;
        return this.classSuperiority[this.archetypeData.name] > 0;
    }
    get hasManeuvers() {
        return this.classSuperiority.baseClass > 0 || this.isArchetypeSuperiority;
    }
    get numberManeuversKnown() {
        const classField = parseInt(this.classData.levelChanges[this.myClass.levels]['Maneuvers Known']);
        let archetypeField = 0;
        if (this.isArchetypeSuperiority) {
            const leveledTable = this.archetypeData.leveledTable;
            if (leveledTable) {
                const maneuversKnownKeyValue = leveledTable[this.myClass.levels].find(({ key }) => key === 'Maneuvers Known');
                archetypeField = maneuversKnownKeyValue ? parseInt(maneuversKnownKeyValue.value) : 0;
            }
        }
        archetypeField = isNaN(archetypeField) ? 0 : archetypeField;
        return isNaN(classField) ? archetypeField : archetypeField || classField;
    }
    handleUpdateManeuvers(newManeuvers) {
        this.$emit('updateManeuvers', { newManeuvers, isArchetype: this.isArchetypeSuperiority });
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderClassManeuvers.prototype, "myClass", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassManeuvers.prototype, "classData", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassManeuvers.prototype, "archetypeData", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassManeuvers.prototype, "settings", void 0);
__decorate([
    Prop(Array)
], CharacterBuilderClassManeuvers.prototype, "allManeuvers", void 0);
__decorate([
    maneuversModule.State
], CharacterBuilderClassManeuvers.prototype, "maneuvers", void 0);
__decorate([
    maneuversModule.Action
], CharacterBuilderClassManeuvers.prototype, "fetchManeuvers", void 0);
CharacterBuilderClassManeuvers = __decorate([
    Component({
        components: {
            CharacterSheetExpansionFeatures,
            CharacterSheetSuperiorityAddManeuver
        }
    })
], CharacterBuilderClassManeuvers);
export default CharacterBuilderClassManeuvers;
